import * as constants from './constants';

const initialState = {
  // User's current GPS location
  userLocation: null, // { lat, lng }

  // Map view state
  mapCenter: null, // { lat, lng }
  mapZoom: 13,

  // Nearby pins data
  pins: [],
  pinsLoading: false,
  pinsError: null,

  // Selected pin/tour
  selectedPin: null,
  selectedTour: null,
  tourMapLoading: false,
  tourMapError: null,
};

export default function mapReducer(state = initialState, action) {
  switch (action.type) {
    // Fetch nearby pins
    case constants.FETCH_NEARBY_PINS_REQUEST:
      return {
        ...state,
        pinsLoading: true,
        pinsError: null,
      };

    case constants.FETCH_NEARBY_PINS_SUCCESS:
      return {
        ...state,
        pinsLoading: false,
        pins: action.payload.pins,
        pinsError: null,
      };

    case constants.FETCH_NEARBY_PINS_FAILURE:
      return {
        ...state,
        pinsLoading: false,
        pinsError: action.payload,
      };

    // Fetch tour map
    case constants.FETCH_TOUR_MAP_REQUEST:
      return {
        ...state,
        tourMapLoading: true,
        tourMapError: null,
      };

    case constants.FETCH_TOUR_MAP_SUCCESS:
      return {
        ...state,
        tourMapLoading: false,
        selectedTour: action.payload,
        tourMapError: null,
      };

    case constants.FETCH_TOUR_MAP_FAILURE:
      return {
        ...state,
        tourMapLoading: false,
        tourMapError: action.payload,
      };

    // Set user location
    case constants.SET_USER_LOCATION:
      return {
        ...state,
        userLocation: action.payload,
        // Also set map center to user location if not set
        mapCenter: state.mapCenter || action.payload,
      };

    // Set map center
    case constants.SET_MAP_CENTER:
      return {
        ...state,
        mapCenter: action.payload,
      };

    // Set map zoom
    case constants.SET_MAP_ZOOM:
      return {
        ...state,
        mapZoom: action.payload.zoom,
      };

    // Select pin
    case constants.SELECT_PIN:
      return {
        ...state,
        selectedPin: action.payload,
      };

    // Clear selected pin
    case constants.CLEAR_SELECTED_PIN:
      return {
        ...state,
        selectedPin: null,
      };

    default:
      return state;
  }
}
